import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';

// Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCol8VFFCa-prscbwo_uaPZI-ZRU2XPGgc",
    authDomain: "ccfc-goodlife.firebaseapp.com",
    projectId: "ccfc-goodlife",
    storageBucket: "ccfc-goodlife.firebasestorage.app",
    messagingSenderId: "927072557627",
    appId: "1:927072557627:web:2baeb1a64ef96c5b601a1e",
    measurementId: "G-R9C8STGQ9W"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const analytics = getAnalytics(app);

export default app;
